import { renderSVG as QRCodeSVG } from 'uqr';
import QRCode from 'qrcode';
import { CapacitorBarcodeScanner, CapacitorBarcodeScannerTypeHint, } from '@capacitor/barcode-scanner';

const BASE_URL = import.meta.env.VITE_SPA_HOST;

export const urlToQRCode = (url) => `data:image/svg+xml,${encodeURIComponent(QRCodeSVG(url))}`;
export const urlToQRCodePNG = async (url) => await QRCode.toDataURL(url, {scale: 8, margin: 0});
export const loadQRCode = async (load) => await urlToQRCodePNG(`${BASE_URL}/loads/${load.uuid}`);
export const companySignupQRCode = (uuid) => urlToQRCode(`${BASE_URL}/signup/?lc=${uuid}`);

export const scanQRCode = (history, type, readyLoads=[]) => async () => {
  const {ScanResult:result} = await CapacitorBarcodeScanner.scanBarcode({
    hint: CapacitorBarcodeScannerTypeHint.QR_CODE,
    scanInstructions: "Scan a QR Code"
  });

  const routeTarget = type + '/';
  if (result && _.includes(result, routeTarget)) {
    const [, id] = result.split(routeTarget);
    switch(type) {
    case 'locations':
      const readyLoadAtLocation = _.find(readyLoads, {location_id: id});
      if (readyLoadAtLocation) return history.push(`/loads/${readyLoadAtLocation.uuid}`);
      return history.push(`/loads/new?location_id=${id}`);
    case 'loads':
      return history.push(`/loads/${id}`);
    default:
      console.warn(`Did not find a ${type} in url:`, result);
      history.push('/');
    }
  } else {
    history.length ? history.goBack() : history.push('/');
  }
}